import { ChevronDown, MapPin } from "lucide-react";
import React, { useEffect, useState } from "react";
import images from "../../assets/images";
import { Dropdown } from "../../components/dropdown/Dropdown";
import {
  useDashboardFsStore,
  usePremisesStore,
  useRegionStore,
  useTaskStore,
} from "../../store/store";
import { DateSelector } from "../../components/DateSelector/DateSelector";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const FsDashboard: React.FC = () => {
  const { allPremises, fetchPremises } = usePremisesStore();
  const { tasks, fetchTasks } = useTaskStore();
  const { regions, fetchRegions } = useRegionStore();
  const { dashboardData, fetchDashboardData } = useDashboardFsStore();

  // Add state for selected region and premises
  const [selectedRegion, setSelectedRegion] = useState<string>("");
  const [selectedPremises, setSelectedPremises] = useState<string>("");
  // const [mapCoords, setMapCoords] = useState<{ lat: number; lng: number }>({
  //   lat: 0,
  //   lng: 0,
  // });
  const [mapAddress, setMapAddress] = useState<string>("Bengaluru, Karnataka");
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [startDate, endDate] = dateRange;

  // useEffect(() => {
  //   // if (!dashboardData) fetchDashboardData();
  //   if (!allPremises.length) fetchPremises();
  //   // if (!tasks.length) fetchTasks();
  // }, [allPremises, regions]);

  useEffect(() => {
    const query: Record<string, string> = {};

    if (selectedRegion) query.region = selectedRegion;
    if (selectedPremises) query.premise = selectedPremises;
    if (startDate) query.startDate = startDate.toISOString().split("T")[0];
    if (endDate) query.endDate = endDate.toISOString().split("T")[0];

    fetchDashboardData(query);
  }, [selectedRegion, selectedPremises, startDate, endDate]);

  const premiseLocations = dashboardData?.mapData?.locations || [];

  const totalPremises = dashboardData?.summary?.premises || 0;
  const totalTasks = dashboardData?.summary?.tasks || 0;
  const totalAssets = dashboardData?.summary?.assets?.total || 0;
  const totalFailedAssets = dashboardData?.summary?.assets?.failed || 0;
  const totalRecentAlerts = dashboardData?.summary?.recentAlerts || 0;

  const totalIncidentsReported = dashboardData?.metrics?.incidentsReported || 0;
  const totalFeedbacksReceived = dashboardData?.metrics?.feedbackReceived || 0;
  const totalAuditFindings = dashboardData?.metrics?.auditFindings || 0;
  const complianceStatus = dashboardData?.metrics?.complianceStatus || 0;

  const handleDateChange = (startDate: Date | null, endDate: Date | null) => {
    setDateRange([startDate, endDate]);

    // fetchDashboardData({
    // startDate: startDate.toISOString().split("T")[0],
    // endDate: endDate.toISOString().split("T")[0],
    // });
  };

  // useEffect(() => {
  //   if (
  //     premiseLocations.length > 0 &&
  //     mapCoords.lat === 0 &&
  //     mapCoords.lng === 0
  //   ) {
  //     setMapCoords({
  //       lat: premiseLocations[0].latitude,
  //       lng: premiseLocations[0].longitude,
  //     });
  //   }
  // }, [premiseLocations, mapCoords.lat, mapCoords.lng]);

  useEffect(() => {
    if (premiseLocations.length > 0 && !selectedRegion && !selectedPremises) {
      const defaultPremise = premiseLocations[0];
      if (defaultPremise?.regionName) {
        setMapAddress(defaultPremise.regionName);
      } else {

        setMapAddress("Bengaluru, Karnataka");
      }
    }
    ///////////

    if (selectedRegion && !selectedPremises) {
      const firstPremiseInRegion = premiseLocations.find(
        (premise) => premise.region === selectedRegion
      );
      // if (firstPremiseInRegion) {
      //   setMapCoords({
      //     lat: firstPremiseInRegion.latitude,
      //     lng: firstPremiseInRegion.longitude,
      //   });
      // }
      if (firstPremiseInRegion?.regionName) {
        //   "HELLO, I'm in firstPremiseInRegion.regionName",
        //   firstPremiseInRegion.regionName
        // );

        setMapAddress(firstPremiseInRegion.regionName);
      } else {

        setMapAddress("Bengaluru, Karnataka");
      }
    }

    ////////////

    if (selectedPremises) {
      const selectedPremise = premiseLocations.find(
        (premise) => (premise.id || premise._id) === selectedPremises 
      );
      // premiseLocations.forEach((premise) => {
      // });
      // if (selectedPremise) {
      //   setMapCoords({
      //     lat: selectedPremise.latitude,
      //     lng: selectedPremise.longitude,
      //   });
      // }
      const address = selectedPremise?.address || selectedPremise?.addressLine1;
      if (address) {
        //   "HELLO, I'm in selectedPremise.name + selectedPremise.address",
        //   selectedPremise.name + address
        // );

        setMapAddress(selectedPremise.name + address);
      } else {

        setMapAddress("Bengaluru, Karnataka");
      }
    }
  }, [selectedRegion, selectedPremises, premiseLocations]);

  const zoomLevel = selectedPremises ? 14 : 10;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: false },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#333",
          font: {
            size: 11,
          },
          maxRotation: 0,
          minRotation: 0,
          maxTicksLimit: 3,
          callback: (value: any, index: any, ticks: any[]) => {
            const label = data.labels[value as number];
            return label.split(" ");
          },
          padding: 10,
          autoSkip: false,
        },
        border: {
          display: true,
          color: "rgba(0, 0, 0, 0.2)",
        },
      },
      y: {
        beginAtZero: true,
        max: 60,
        ticks: {
          stepSize: 10,
          color: "#333",
          font: {
            size: 12,
          },
        },
        grid: {
          color: "rgba(0, 0, 0, 0.1)",
          drawBorder: false,
        },
        border: {
          display: false,
        },
      },
    },
  };

  const data = {
    labels: ["Team Availability", "Ongoing tasks", "Scheduled inspections"],
    datasets: [
      {
        label: "Team Activity",
        data: [55, 52, 26],
        backgroundColor: ["#68a7ba", "#7ecb89", "#7073b7"],
        borderRadius: 4,
        barThickness: 15,
      },
    ],
  };

  return (
    <div className=" w-full px-2 h-screen mt-20 ">
      <div className="page-header  ">
        <h2 className="header-title ml-2">Dashboard</h2>

        <div className="dashHeaderRight">
          {/* <div className="input-affix dashHeaderinput"> */}
          {/* <i className="prefix-icon anticon anticon-calendar"></i> */}
          {/* <input
              type="date"
              value="30/01/2025"
              className=" mr-4 flex items-center  bg-white  border-2 border-[#a5b7cf] rounded-lg px-2 py-2 w-64 "
              placeholder="Pick a date"
            /> */}
          {/* </div> */}
          <div className="pr-4">
            <DateSelector onDateChange={handleDateChange} />
          </div>

          <span className="flex gap-8">
            {/* Regions Dropdown */}
            <Dropdown
              selectedValue={selectedRegion}
              onChange={(value) => {
                setSelectedRegion(value);
                setSelectedPremises("");
              }}
              type="region"
            />
            {/* Premises Dropdown */}
            <Dropdown
              selectedValue={selectedPremises}
              onChange={setSelectedPremises}
              type="premises"
              selectedRegion={selectedRegion}
            />
            {/* <span className="flex items-center">
              <button className="flex items-center justify-center font-semibold gap-3 bg-[#0fa9a6] text-white px-4 py-2 rounded-full">
                <img
                  src={images.lawIcon}
                  alt=""
                  className="w-6 h-6 text-white"
                />
                EVALUATION
              </button>
            </span> */}
          </span>
        </div>
      </div>

      <div className="cardNum">
        <div className="row">
          <div className="col-sm-3">
            <div className="card p-4">
              <div className="cardIconCont">
                <p>Premises (Total)</p>
                <h3>{totalPremises}</h3>
              </div>

              <div className="cardIcon cardIconColor1">
                <img src={images.premisesIcon} alt="" />
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="card p-4">
              <div className="cardIconCont">
                <p>
                  Assets <span>(Failed over total)</span>{" "}
                </p>
                <h3>
                  {totalFailedAssets} <span>/ {totalAssets}</span>{" "}
                </h3>
              </div>

              <div className="cardIcon cardIconColor2">
                <img src={images.assetsIcon} alt="" />
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="card p-4">
              <div className="cardIconCont">
                <p>Recent Alerts</p>
                <h3>{totalRecentAlerts}</h3>
              </div>

              <div className="cardIcon cardIconColor3">
                <img src={images.alertsIcon} alt="" />
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="card p-4">
              <div className="cardIconCont">
                <p>Tasks</p>
                <h3>{totalTasks}</h3>
              </div>

              <div className="cardIcon cardIconColor4">
                <img src={images.tasksIcon} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="dashCont">
        <div className="row">
          <div className="col-md-9 iframeMap">
            <div className="card">
              <iframe
                // src={`https://maps.google.com/maps?q=${mapCoords.lat},${mapCoords.lng}&z=15&output=embed`}
                src={`https://maps.google.com/maps?q=${encodeURIComponent(
                  mapAddress
                )}&z=${zoomLevel}&output=embed`}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          <div className="col-md-3 cardNum">
            <div className="card">
              <div className="cardIconCont">
                <p> Incidents Reported</p>
                <h5>{totalIncidentsReported}</h5>
              </div>

              <div className="cardIcon">
                <img src={images.reportedIcon} alt="reportedicon" />
              </div>
            </div>

            <div className="card">
              <div className="cardIconCont">
                <p>Feedback Received</p>
                <h5>{totalFeedbacksReceived}</h5>
              </div>

              <div className="cardIcon">
                <img src={images.feedbackIcon} alt="FeedbackcardIcon" />
              </div>
            </div>

            <div className="card">
              <div className="cardIconCont">
                <p>Findings Of Internal /External Audits</p>
                <h5>{totalAuditFindings}</h5>
              </div>

              <div className="cardIcon">
                <img src={images.auditsIcon} alt="" />
              </div>
            </div>

            <div className="card">
              <div className="cardIconCont">
                <p>Compliance Status</p>
                <h5>{complianceStatus}</h5>
              </div>

              <div className="cardIcon">
                <img src={images.complianceIcon} alt="" />
              </div>
            </div>
          </div>

          {/* <div className="col-md-3">
            <div className="card">
              <div className="card-body minHeightTactivity">
                <h2 className="text-lg font-semibold mb-3">Team Activity</h2>
                <div
                  style={{
                    width: "100%",
                    height: "260px",
                    position: "relative",
                  }}
                >
                  <Bar data={data} options={options} />
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default FsDashboard;
